import type { GraphEdgeBase } from '../graphItems/GraphEdgeBase';
import type { RelationshipDiagramViewModel } from '../viewModel/types';
import type { RelationshipsLink } from './types';

interface EdgesToLinksReducerState {
  links: RelationshipsLink[];
  linksBySourceAndTarget: Map<string, RelationshipsLink[]>;
  viewModel: RelationshipDiagramViewModel;
}

const edgesToLinks = (state: EdgesToLinksReducerState, edge: GraphEdgeBase) => {
  const {
    links,
    linksBySourceAndTarget,
    viewModel: { nodes, groups },
  } = state;
  const sourceAndTargetId = `${edge.source}-${edge.target}`;
  const targetAndSourceId = `${edge.target}-${edge.source}`;
  const matchingLinks =
    linksBySourceAndTarget.get(sourceAndTargetId) ??
    linksBySourceAndTarget.get(targetAndSourceId);
  const similarLinks = matchingLinks ?? [];
  if (!matchingLinks) {
    linksBySourceAndTarget.set(sourceAndTargetId, similarLinks);
  }

  similarLinks.forEach(link => link.similarLinksCount++);
  const similarLinksCount = similarLinks.length;
  const [source, target] = [edge.source, edge.target].map(
    id => nodes.byId.get(id) ?? groups.byId.get(id)
  );
  if (source && target) {
    const link = {
      edge,
      source,
      target,
      similarLinksIndex: similarLinksCount,
      similarLinksCount: similarLinksCount + 1,
    };
    links.push(link);
    similarLinks.push(link);
  }
  return state;
};
export { edgesToLinks };
